/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import { Styled } from 'components/ITeroTermsConditionsModal';
import { useI18n } from 'contexts/i18n';
import React from 'react';

const ServicePlanTermEMEA: React.FC<{
  servicePlanFee: string | undefined;
}> = ({ servicePlanFee = '' }) => {
  const i18n = useI18n();
  return (
    <Styled.ServicePlanTermWrapper>
      <div>
        <i>
          {i18n['iTero Service Plan Details - Footer note 1 - EMEA']}{' '}
          <a
            href={'https://itero.com/rpa_emea'}
            target={'_blank'}
            rel="noreferrer"
          >
            https://itero.com/rpa_emea
          </a>
        </i>
      </div>
      <div>
        <i>
          {i18n['iTero Service Plan Details - Footer note 2 - EMEA'].replace(
            '{DYNAMIC_SERVICE_PLAN_FEE}',
            servicePlanFee
          )}
        </i>
      </div>
    </Styled.ServicePlanTermWrapper>
  );
};

export default ServicePlanTermEMEA;
